import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundaryNew";
import NotFound from "pages/NotFound";
import HomeLanding from './pages/home-landing';
import JobBoard from './pages/job-board';
import UserDashboard from './pages/user-dashboard';
import PostJob from './pages/post-job';
import Messages from './pages/messages';
import Authentication from './pages/authentication';
import UserProfile from './pages/user-profile';
import Notifications from './pages/notifications';
import WorkerProfile from './pages/worker-profile';
import Profile from './pages/profile';
import Earnings from './pages/earnings';
import FindWork from './pages/find-work';
import ServiceProviders from './pages/service-providers';
import AdminDashboard from './pages/admin-dashboard';

// Wrapper component for individual routes with error boundaries
const RouteWrapper = ({ children, routeName }) => (
  <ErrorBoundary key={routeName}>
    {children}
  </ErrorBoundary>
);

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<RouteWrapper routeName="home"><HomeLanding /></RouteWrapper>} />
        <Route path="/home-landing" element={<RouteWrapper routeName="home-landing"><HomeLanding /></RouteWrapper>} />
        <Route path="/job-board" element={<RouteWrapper routeName="job-board"><JobBoard /></RouteWrapper>} />
        <Route path="/user-dashboard" element={<RouteWrapper routeName="user-dashboard"><UserDashboard /></RouteWrapper>} />
        <Route path="/post-job" element={<RouteWrapper routeName="post-job"><PostJob /></RouteWrapper>} />
        <Route path="/messages" element={<RouteWrapper routeName="messages"><Messages /></RouteWrapper>} />
        <Route path="/authentication" element={<RouteWrapper routeName="authentication"><Authentication /></RouteWrapper>} />
        <Route path="/user-profile" element={<RouteWrapper routeName="user-profile"><UserProfile /></RouteWrapper>} />
        <Route path="/worker-profile" element={<RouteWrapper routeName="worker-profile"><WorkerProfile /></RouteWrapper>} />
        <Route path="/profile" element={<RouteWrapper routeName="profile"><Profile /></RouteWrapper>} />
        <Route path="/notifications" element={<RouteWrapper routeName="notifications"><Notifications /></RouteWrapper>} />
        <Route path="/earnings" element={<RouteWrapper routeName="earnings"><Earnings /></RouteWrapper>} />
        <Route path="/find-work" element={<RouteWrapper routeName="find-work"><FindWork /></RouteWrapper>} />
        <Route path="/service-providers" element={<RouteWrapper routeName="service-providers"><ServiceProviders /></RouteWrapper>} />
        <Route path="/admin-dashboard" element={<RouteWrapper routeName="admin-dashboard"><AdminDashboard /></RouteWrapper>} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
